'use client';

import { ButtonProps } from '@theme/components/types';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

export const Button = (props: ButtonProps) => {
  return (
    <button
      {...props}
      className={twMerge(
        clsx(
          [
            'px-6',
            'h-10',
            'text-sm',
            'bg-white',
            'text-black-100',
            'border',
            'border-white',
            'transition-all',
            'hover:bg-opacity-80',
            'hover:text-black-100',
            'rounded-[3.125rem]'
          ],
          props.appearance === 'outlined' && [
            'bg-transparent ',
            'text-primary ',
            'hover:bg-primary ',
            'hover:text-primary-foreground'
          ],
          props.appearance === 'ghost' && [
            'bg-transparent',
            'border-transparent',
            'text-primary',
            'hover:bg-primary',
            'hover:text-primary-foreground'
          ]
        ),
        props.className
      )}
    >
      {props.children}
    </button>
  );
};
